<template>
    <div>
        <h5>Paso 2: Ingrese la información para generar contenido</h5>
        <hr />
        <div v-on="obtenerInicializarFormulario ?this.inicializarFormulario():this.noHacerNada()">
            <div> 
                <div class="contenedor-puntero">
                    <h6>[Agregando contenido en: {{obtenerPunterosParaContenido.paginaWebSeleccionada + '/' + obtenerPunterosParaContenido.rutaSecciones}}]</h6>
                </div>
                <div class="contenedor-cambio-seccion">
                    <div>
                        <button type="button" class="btn btn-primary" @click="cambioDeSeccion"><i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Cambiar de Sección</button>
                    </div> 
                </div>
                <hr />
            </div>
            <div v-if="obtenerCamposRequeridosEnFormulario.tipoDeFormulario == 'comunicado'">
                 <div class="contenedor-cambio-seccion">
                    <div v-if="obtenerCamposRequeridosEnFormulario.opcionesComunicadoUrgente.requerido" class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons">
                        <label class="btn btn-secondary active" @click="informativoRadio=true, urgenteRadio=false">
                            <input type="radio" name="options" id="radioCaracterUrgente" autocomplete="off"  checked>Carácter Informativo
                        </label>
                        <label class="btn btn-secondary" v-tooltip:top="textoEsNoticiaUrgente" @click="urgenteRadio=true, informativoRadio=false">
                            <input type="radio" name="options" id="radioCaracterInformativo" autocomplete="off" >Carácter Urgente
                        </label>
                    </div>

                    <div class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons">
                        <label class="btn btn-secondary" v-tooltip:top="textoEsPin" @click="esPin = true">
                            <input type="radio" name="options" id="radioEsPin" autocomplete="off"  checked><i class="fas fa-thumbtack"></i>&nbsp;&nbsp;Agregar pin
                        </label>
                        <label class="btn btn-secondary active" @click="esPin = false">
                            <input type="radio" name="options" id="radioNoEsPin" autocomplete="off" >Sin pin
                        </label>
                    </div>
                </div>
                <hr />
            </div>
            <div v-if="obtenerCamposRequeridosEnFormulario.titulo.requerido">
                <h6>Ingrese un título</h6>
                <input v-model="titulo" type="text" id="titulo_contenido" :class="[!this.campoEsValidoFormulario(titulo) && mostrarErroresInput && !obtenerCambiarFormulario? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el título" />
                <hr />
            </div>
            <div v-if="obtenerCamposRequeridosEnFormulario.nombrePresidente.requerido">
                <h6>Ingrese el nombre de la persona</h6>
                <input v-model="nombrePresidente" type="text" id="nombrePresidente_contenido" :class="[!this.campoEsValidoFormulario(nombrePresidente) && mostrarErroresInput && !obtenerCambiarFormulario? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el nombre de la persona" />
                <hr />
            </div>
            <div v-if="obtenerCamposRequeridosEnFormulario.catalogoPoderes.requerido">
                <div class="row justify-content-between">
                    <div class="form-group col-9 col-sm-9 col-md-9 col-lg-9 pr-0 mb-0">
                        <h6>Designado por</h6>
                        <CSelectGenerico class="p-0 m-0" v-on:valorParaElPadre="cambioCatalogoPoderes" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'catalogo-poderes-pasoDos'" :valorDefinido="-1" :key="'catalogo-poderes-pasoDos'" :elementos="PODERES" :mansajeValorDefinidoPlural="'los poderes que designan'" :mansajeValorDefinidoSingular="'el poder que designa'"></CSelectGenerico>
                    </div>
                     <div class="form-group col-3 col-sm-3 col-md-3 col-lg-3 pr-0 mb-0">
                        <h6>Es suplente</h6>
                        <div class="btn-group btn-group-toggle mb-0 pr-0" data-toggle="buttons">
                            <label id="descargaRadio-toggle" :class="[esSuplente ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="esSuplente = true">
                                <input type="radio" name="options" id="radioArchivoDeDescarga" autocomplete="off"  checked>Si
                            </label>
                            <label id="vinculoRadio-toggle" :class="[!esSuplente ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="esSuplente = false">
                                <input type="radio" name="options" id="radioLinkAOtraPagina" autocomplete="off" >No
                            </label>
                        </div>
                    </div> 
                </div>
                <hr />
            </div>
            <div v-if="obtenerCamposRequeridosEnFormulario.rangoPresidente.requerido">
                <h6>Ingrese el periodo de tiempo en el que fue presidente</h6>
                <input v-model="rangoPresidente" type="text" id="rangoPresidente_contenido" :class="[!this.campoEsValidoFormulario(rangoPresidente) && mostrarErroresInput && !obtenerCambiarFormulario? 'form-control border border-danger': 'form-control']" placeholder="2014 - 2020" />
                <hr />
            </div>
            <div v-if="obtenerCamposRequeridosEnFormulario.textoDelContenido.requerido">
                <h6>Ingrese una descripción</h6>
                <textarea  v-model="textoDelContenido" type="text" rows="3" id="descripcion_contenido" :class="[!this.campoEsValidoFormulario(textoDelContenido) && mostrarErroresInput && !obtenerCambiarFormulario ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese una descripción" />
                <hr />
            </div>
            <div v-if="obtenerCamposRequeridosEnFormulario.imagenDeContenido.requerido">
                <h6>Seleccione la imagen del contenido</h6>
                <input type="file" id="imagen_contenido" ref="" :class="[!this.campoEsValidoFormulario(this.IMAGEN_CONTENIDO) && mostrarErroresInput && !obtenerCambiarFormulario  ? 'form-control border border-danger': 'form-control']" v-on:change="subirImagen($event)" accept=".JPEG,.JPG,.PNG" />
                <hr />
            </div>
            <!-- imagenes -->
            <div v-if="listadoImagenesObligaciones.length > 0">
                <h6>Seleccione una imagen para la obligacion</h6>
                <CListaDeImagenes :estilosExtraDiv="'display: inline-block; border-radius:8px; overflow-y: auto; background-color:#212529; max-height: 212px;'" :estilosExtraUl="'margin-left: 3.5em; margin-bottom: 1em;'" v-on:cargarImagenes="recargarImagenesPredeterminadas" v-on:valorParaElPadre="seleccionImagenObligaciones" :idListaDeImagenes="'lista-imagenes-obligaciones'" :listaDeImagenes="listadoImagenesObligaciones"></CListaDeImagenes>
                <hr />
            </div>
            <div v-if="obtenerCamposRequeridosEnFormulario.archivosDeContenido.requerido" class="contenedor-seccion-archivos">
                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                    <label id="descargaRadio-toggle" :class="[descargaRadio ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="evtToggleArchivo">
                        <input type="radio" name="options" id="radioArchivoDeDescarga" autocomplete="off"  checked>Archivo
                    </label>
                    <label id="vinculoRadio-toggle" :class="[vinculoRadio ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="eventoOpcionVinculoAotraPagina">
                        <input type="radio" name="options" id="radioLinkAOtraPagina" autocomplete="off" >Vínculo a otra página
                    </label>
                </div>
                <div v-if="mostrarTextoDelVinculo()">
                     <h6>Ingrese texto del vínculo</h6>
                     <input v-model="textoVinculoArchivo" type="text" id="texto_vinculo_archivo" :class="[!this.campoEsValidoFormulario(textoVinculoArchivo) && mostrarErroresInput && !obtenerCambiarFormulario? 'form-control': 'form-control']" placeholder="Ingrese texto del vínculo para el archivo" />
                </div>
                <div v-if="descargaRadio && obtenerCamposRequeridosEnFormulario.archivoConVinculo.requerido" class="btn-group btn-group-toggle elementos-archivos-contenido" data-toggle="buttons">
                    <label :class="[descargaArchivoRadio ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="descargaArchivoRadio=true, vinculoArchivoRadio=false">
                        <input type="radio" name="options" id="radioArchivoDeDescarga" autocomplete="off"  checked>Archivo de descarga
                    </label>
                    <label :class="[vinculoArchivoRadio ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="vinculoArchivoRadio=true, descargaArchivoRadio=false">
                        <input type="radio" name="options" id="radioLinkAOtraPagina" autocomplete="off" >Vínculo del archivo
                    </label>
                </div>
                <div class="elementos-archivos-contenido" v-if="vinculoRadio">
                    <h6>Ingrese el vínculo a otra página (URL)</h6>
                    <input v-model="vinculo" type="text" id="vinculo_contenido" :class="[!this.campoEsValidoFormulario(vinculo) && mostrarErroresInput && !obtenerCambiarFormulario &&  listaDeArchivos.length == 0 ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el vínculo" />
                </div>
                <!-- MOSTRAR EN VISOR -->
                <div v-if="!obtenerCamposRequeridosEnFormulario.listaDeArchivos.requerido && descargaRadio" class="mt-3 mb-0">
                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                        <label :class="(archivos.mostrarEnVisor) ? 'btn btn-secondary active' : 'btn btn-secondary'" v-tooltip:top="archivos.MSJ_TOOLTIP" @click="archivos.mostrarEnVisor = true">
                            <input type="radio" name="options" id="radioEsPin" autocomplete="off"  checked>Mostrar en visor
                        </label>
                        <label :class="(!archivos.mostrarEnVisor) ? 'btn btn-secondary active' : 'btn btn-secondary'" @click="archivos.mostrarEnVisor = false">
                            <input type="radio" name="options" id="radioNoEsPin" autocomplete="off" >No mostrar en visor
                        </label>
                    </div>
                </div>
                <div v-if="this.validarOpcionToggleArchivo()" :class="[this.validarOpcionToggleArchivo() ? 'elementos-archivos-contenido' : '']">
                    <h6>Seleccione el archivo de descarga</h6>
                    <input type="file" id="descarga_contenido" ref="" :class="[!this.campoEsValidoFormulario(this.ARCHIVO_DESCARGA) && mostrarErroresInput && !obtenerCambiarFormulario &&  listaDeArchivos.length == 0? 'form-control border border-danger': 'form-control']" v-on:change="subirArchivoDescarga($event)" accept=".PDF,.XLSX,.XLSB,.ZIP" />
                </div>
                 <div v-if="descargaRadio && vinculoArchivoRadio">
                    <h6>Ingrese el vínculo(URL)</h6>
                    <input v-model="vinculo" type="text" id="vinculo_contenido" :class="[!this.campoEsValidoFormulario(vinculo) && mostrarErroresInput && !obtenerCambiarFormulario &&  listaDeArchivos.length == 0 ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el vínculo" />
                </div>
                 <div v-if="obtenerCamposRequeridosEnFormulario.listaDeArchivos.requerido && descargaRadio" class="elementos-archivos-contenido text-right">
                    <div>
                        <button type="button" class="btn btn-primary" @click="agregarArchivosAcontenido"><i class="fas fa-file-upload"></i>&nbsp;&nbsp;Agregar&nbsp;{{textoBotonAgregaraAoV}}</button>
                    </div> 
                </div>  
                <div class="elementos-archivos-contenido" v-if="listaDeArchivos.length > 0 && obtenerCamposRequeridosEnFormulario.listaDeArchivos.requerido && descargaRadio">
                    <div style="display: flex;">
                        <h6>Numero de archivos agregados: {{listaDeArchivos.length}}</h6>
                        <div v-if="listaDeArchivos.length > 1" class="opciones-vaciar-listaDeArchivos">
                            <div class="linea-vertical"></div>
                            <span style="margin-left: 6px;"><i class="fas fa-folder-minus" style="cursor: pointer; font-size: 1.5em;" @click="informarVaciarListaDeArchivosAgregados" v-tooltip:top="'Eliminar todos los archivos agregados'"></i></span>
                        </div>
                    </div>
                    <div :class="[listaDeArchivos.length > 100 ? 'contenedor-listado-archivos' :'contenedor-listado-archivos']">
                        <table id="tabla-archivos-descarga" class="table table-dark" style="width: 100%; heigth: 100%">
                            <thead>
                                <tr>
                                <th style="width: 40%" scope="col">Nombre del archivo</th>
                                <th style="width: 30%" scope="col">Texto del vínculo</th>
                                <th style="width: 10%" scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(archivo,index) in listaDeArchivos" :key="'Archivo' + index">
                                    <td v-if="archivo.NombreEnServidor != 'VinculoPrincipal'" style="width: 40%">{{archivo.NombreBase}}</td>
                                    <td v-if="archivo.NombreEnServidor != 'VinculoPrincipal'" style="width: 30%">{{archivo.TextoDelVinculo}}</td>
                                    <td v-if="archivo.NombreEnServidor != 'VinculoPrincipal'" class="text-center mx-auto" style="width: 10%"><i :id="archivo.NombreEnServidor" class="fas fa-trash-alt elemento-eliminar-archivo" @click="informarSacarArchivoDeLista($event)" v-tooltip:right="'Eliminar archivo de la lista'" style="font-size: 1.5em;"></i></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div> 
                <hr />
            </div>
            <div v-if="obtenerCamposRequeridosEnFormulario.fechaDePublicacion.requerido">
                <h6 >Ingrese fecha de publicación</h6>
                <div style="display: flex;">
                    <div style="display: flex; align-items: center;">
                        <h6 v-if="urgenteRadio" style="margin-right: 5px;">Inicio </h6>
                        <datepicker :key="'dtPkInicio'" 
                                    :format="DatePickerFormato"  
                                    :highlighted="highlighted_DtPkInicio"
                                    :disabled-dates="disabledDates_DtPkInicio" 
                                    v-model="fechaDatePickerInicio"
                                    @selected="seleccionDeFechaDtPkInicio"  
                                    :value="this.fechaDefaultDtPkInicio" 
                                    :bootstrap-styling="true"
                                    :calendar-button="true"
                                    calendar-button-icon="far fa-calendar-alt" 
                                    name="fecha" 
                                    :language="languaje"></datepicker>
                    </div>
                    <div v-if="urgenteRadio" style="display: flex; align-items: center;">
                            <h6 style="margin-right: 5px;">Fin </h6>
                            <datepicker :key="'dtPkFin'" 
                                        :format="DatePickerFormato"  
                                        :highlighted="highlighted_DtPkFin"
                                        :disabled-dates="disabledDates_DtPkFin" 
                                        v-model="fechaDatePickerfinal"
                                        @selected="seleccionDeFechaDtPkFin"  
                                        :value="this.fechaDefaultDtPkFinal" 
                                        :bootstrap-styling="true"
                                        :calendar-button="true"
                                        calendar-button-icon="far fa-calendar-alt"  
                                        :class="{'texto-negro': true}" name="fecha" 
                                        :language="languaje"></datepicker>
                    </div>
                </div>
                <hr />
            </div>   
            <div v-if="obtenerCamposRequeridosEnFormulario.disposicionEspecial.requerido">
                <div>
                    <div v-if="obtenerCamposRequeridosEnFormulario.tipoDeFormulario == 'comunicado'" style="display:flex; justify-content: space-between;">
                        <div class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons">
                            <label :class="[disposicionEspecial ? 'btn btn-secondary active' : 'btn btn-secondary']" v-tooltip:top="textoDisposicionEspecial" @click="disposicionEspecial = true">
                                <input type="radio" name="options" id="radioEsDisposicionEspecial" autocomplete="off"  checked>Es disposición especial
                            </label>
                            <label :class="[!disposicionEspecial ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="disposicionEspecial = false, tipoSubmenuId=-1,textoTituloSubmenu=null">
                                <input type="radio" name="options" id="radioNoEsDisposicionEspecial" autocomplete="off" >No es disposición especial
                            </label>
                        </div>
                        <C006Submenus v-if="disposicionEspecial"  style="padding:0; margin:0; width: 330px;" v-on:valorParaElPadre="cambioTipoSubmenu" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'catalogoSubmenusPasoDos'" :parametros="{SubmenuId: null, MenuId:40, PaginaWebId:null, SubmenuIdDelQuePertenezco:null, SubmenuIdQueMePertenece:null, ConInactivos:false, ConMenu:false, ConMenusLosSubmenus:false, ConSubmenusQueMePertenecen:false, ConTodosLosSubmenusQueMePertenecen: false, ConTodasLasPaginasWebDelSubmenu:false, ConSubmenuDelQueDesciende:false, ConPaginasWeb:false, ConOrdenamiento:false, ConOrdenamientoDeLosSubmenus:false, SoloPermiteSubirContenido:true}" :valorDefinido="-1" :key="0"></C006Submenus>
                    </div>
                    <div v-if="disposicionEspecial || obtenerCamposRequeridosEnFormulario.tipoDeFormulario != 'comunicado'">
                        <br v-if="obtenerCamposRequeridosEnFormulario.tipoDeFormulario == 'comunicado'">
                        <h6>Ingrese título del submenu</h6>
                        <input v-model="textoTituloSubmenu" type="text" id="texto_titulo_submenu" :class="[!this.campoEsValidoFormulario(textoTituloSubmenu) && mostrarErroresInput && !obtenerCambiarFormulario? 'form-control border border-danger': 'form-control']" placeholder="Ingrese un título para el submenu" />
                    </div>
                </div>
                <hr />
            </div>
            <div class="text-right">
                <div>
                    <button type="button" class="btn btn-primary" @click="agregarContenido"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                </div> 
            </div>    
        </div>
    </div>
</template>
<script>

import api from '@/../static/js/api'
import axios from 'axios'
import comun from "@/../static/js/comun"
import enumeraciones from '@/../static/js/enumeraciones'
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
import C006Submenus from '../../Catalogos/C006Submenus.vue'
import Datepicker from 'vuejs-datepicker';
import CSelectGenerico from '@/components/SICPO/Comun/CSelectGenerico.vue'
import CListaDeImagenes from '../../Comun/CListaDeImagenes.vue'

export default {
    directives: {
        tooltipF
    },
    data() {
        return {
            fechaDatePickerInicio: new Date(),
            fechaDatePickerfinal: new Date(),
            fechaSeleccionada: 0,
            fechaDefaultDtPkInicio: new Date(),
            fechaDefaultDtPkFinal: new Date(),
            DatePickerFormato: 'yyyy-MM-dd',
            languaje:{
                language: 'es',
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                monthsAbbr: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                days: ['D','L', 'M', 'M', 'J', 'V', 'S'],
                rtl: false,
                ymd: 'yyyy-MM-dd',
                yearSuffix: ''
            },
            highlighted_DtPkInicio: {
                customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaFin = this.obtenerFecha(this.fechaDatePickerfinal);
                    let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
                    if(this.informativoRadio) {
                        if(diasDeMes == fechaInicio) {
                            return true
                        }
                    }
                    else if(this.urgenteRadio) {
                        if(diasDeMes >= fechaInicio && diasDeMes <= fechaFin) {
                             return true
                        }
                    }
                },
                includeDisabled: false
            },
            highlighted_DtPkFin: { 
                customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaFin = this.obtenerFecha(this.fechaDatePickerfinal);
                    let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
                    if(diasDeMes >= fechaInicio && diasDeMes <= fechaFin) {
                        return true
                    }
                },
                includeDisabled: false
            },
            disabledDates_DtPkInicio: {
                 customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaActual = this.obtenerFecha(new Date());
                    if(diasDeMes < fechaActual)
                        return true
                }
            },
            disabledDates_DtPkFin: {
                 customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
                    if(diasDeMes < fechaInicio){
                        return true
                    }
                }
            },
            enumeraciones,
            textoDelContenido: null,
            IMAGEN_CONTENIDO: null,
            ARCHIVO_DESCARGA: null,
            mostrarSubidorDeArchivos: false,
            fechaDePublicacion: '',
            fechaDePublicacionFin: '',
            titulo: '',
            textoVinculo: null,
            textoVinculoArchivo: null,
            textoVinculoPrincipal: null,
            vinculo: null,
            tituloArchivo: null,
            nombrePresidente: null,
            rangoPresidente: null,
            textoMensajeCampoFaltante:'',
            mostrarErroresInput: false,
            existePerdidaDeCambios: false,
            descargaRadio: true,
            vinculoRadio: false,
            textoBotonAgregaraAoV: 'Archivo',
            descargaArchivoRadio: true,
            vinculoArchivoRadio: false,
            vinculoArchivo: null,
            urgenteRadio: false,
            informativoRadio: false,
            sobreescribirArchivo: false,
            listaDeArchivos: [],
            listaDeArchivosBit:new Object(),
            contadorArchivos: 0,
            opcionVaciarListaArchivos: false,
            disposicionEspecial: false,
            esPin: false,
            textoTituloSubmenu: null,
            textoDisposicionEspecial: 'Esta opcion sirve para indicar que este contenido se incluira como disposicion especial dentro del menú de disposiciones de la página oficial',
            textoEsPin: 'Esta opción sirve para indicar que este contenido permanecerá fijado en la página oficial',
            textoEsNoticiaUrgente: 'Si esta opción es seleccionada esta noticia se mostrará en un pop-up al ingresar a la página oficial',
            PODERES: [
                {  
                    valor: 1,
                    nombre:'Poder Ejecutivo Estatal'
                },
                {   
                    valor: 2,
                    nombre:'Poder Judicial'
                },
                {   
                    valor: 3,
                    nombre:'Poder Legislativo'
                }
            ],
            poderQueDesigna: '',
            listadoImagenesObligaciones: [],
            imagenDeObligacion: null,
            tipoSubmenuId: -1,
            esSuplente: false,
            archivos: {
                mostrarEnVisor: false,
                MSJ_TOOLTIP: 'Esta opción sirve para indicar que el archivo del contenido se mostrara en el visor de documentos de la página oficial'
            }
        }
    },
    components: {
        C006Submenus,
        Datepicker,
        CSelectGenerico,
        CListaDeImagenes
    },
    methods: {
        evtToggleArchivo: function() {
            if(!this.descargaRadio) {
                this.descargaRadio = true, 
                this.vinculoRadio = false, 
                this.vinculo = null, 
                this.textoBotonAgregaraAoV = 'Archivo', 
                this.listaDeArchivos = [], 
                this.ARCHIVO_DESCARGA = null
            }
        },
        seleccionImagenObligaciones: function(evento,imagenEstaSeleccionada) {  
            if(imagenEstaSeleccionada) 
                this.imagenDeObligacion = evento.target.getAttribute('id'); 
            else
                this.imagenDeObligacion = null;      
        },
        recargarImagenesPredeterminadas: function(evento) {
            this.listadoImagenesObligaciones = this.obtenerListaDeImagenesObligaciones();
        },
         /**
         * Metodo para manejar evento de datepicker fecha inicial. 
         * verifica si la fecha de inicio es menor para actualizar el valor de fecha
         * final dinamicamente.
         */
        seleccionDeFechaDtPkInicio: function() {
            this.$nextTick(() => {
                let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
                let fechaFinal = this.obtenerFecha(this.fechaDatePickerfinal);
                if(fechaInicio > fechaFinal) {
                    this.fechaDatePickerfinal = this.fechaDatePickerInicio;
                    this.fechaDefaultDtPkFinal = this.fechaDatePickerInicio;
                }
            });
        },
        /**
         * Metodo para manejar evento de datepicker fecha inicial. 
         * En caso de no requerirse eliminar metodo
         */
        seleccionDeFechaDtPkFin: function() {
           // de momento no hay logica aqui utilizar despues
        },
        /**
         * Metodo para agregar elemtos tipo archivo al listado que tendra el contenido que se dara de alta,
         * valida si el contenido requiere lista de archivos o solo un archivo.
         */
        agregarArchivosAcontenido: function() {
            if(!this.obtenerCamposRequeridosEnFormulario.listaDeArchivos.requerido && this.listaDeArchivos.length == 1) {
                comun.mensajeDeAlerta('Este contenido solo necesita un archivo o viculo a otra pagina ya has agregado uno,<br>Si deseas cambiar el archivo presione el icono de eliminar y repita el proceso para agregar un archivo o vinculo a otra pagina', null, null);
            }
            else {
                this.agregarArchivoEnListado();
            }
        },
        /**
         * Metodo encargado de construir objeto tipo archivo y posteriormente agregarlo al listado de archivos.
         */
        agregarArchivoEnListado: function() {
            let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
            let camposValidos = true;
            let identificadoresDeArchivo = this.identificardorTipoRutaArchivo();
            if(this.campoEsValidoFormulario(identificadoresDeArchivo.rutaDeArchivo)) {
                let vinculoAotraPaginaEncontrado = this.existeVinculoAotraPagina();
                // se valida que no exita otro archivo con el mismo nombre en su lista temporal de archivos
                if(identificadoresDeArchivo.nombreServidor == 'VinculoPrincipal' && vinculoAotraPaginaEncontrado.existe) {
                    comun.mensajeDeAlerta(`Solo se permite un vinculo a otra pagina y has agregado uno [${vinculoAotraPaginaEncontrado.nombreDelVinculo}], <br>Si deseas cambiar el vinculo a otra pagina presione el icono de eliminar y repita el proceso para agregar un vinculo a otra pagina`, null, null);
                }
                else if(this.obtenerCamposRequeridosEnFormulario.listaDeArchivos.requerido && this.listaDeArchivos.length >= 1 && this.existeUnArchivoConEsteNombre(identificadoresDeArchivo.nombreBase,identificadoresDeArchivo.nombreServidor)) {
                    comun.mensajeDeAlerta('No se permiten archivos con el mismo nombre, <br>Cambia el nombre del archivo o elimina el que se encuentra en la lista', null, null);
                }
                else {
                    let objetoArchivo = {};
                /*  Agregar en caso de necesitarlo en peticion para el alta de contenido
                    objetoArchivo.ArchivoDeContenidoId = -1; 
                    objetoArchivo.ContenidoDeLaPaginaWeb = {objeto de contenido} */
                    objetoArchivo.NombreBase = identificadoresDeArchivo.nombreBase;
                    // llave para identificar los archivos en servidor
                    objetoArchivo.NombreEnServidor = identificadoresDeArchivo.nombreServidor;
                    objetoArchivo.RutaDelArchivo = identificadoresDeArchivo.rutaDeArchivo;
                    objetoArchivo.MostrarEnVisor = (identificadoresDeArchivo.mostrarEnVisor != null && identificadoresDeArchivo.mostrarEnVisor != undefined) ? identificadoresDeArchivo.mostrarEnVisor : null;
                    objetoArchivo.Titulo = (this.campoEsValidoFormulario(this.tituloArchivo))? this.tituloArchivo : 'Sin título';
                    objetoArchivo.FechaDeRegistro = this.fechaDePublicacion;
                    objetoArchivo.TextoDelVinculo = (this.campoEsValidoFormulario(this.textoVinculoArchivo))? this.textoVinculoArchivo : 'Sin texto de vínculo';
                    this.listaDeArchivos.push(objetoArchivo);
                    this.existePerdidaDeCambios = true;
                    this.listaDeArchivosBit[objetoArchivo.NombreEnServidor] = this.ARCHIVO_DESCARGA;
                    this.contadorArchivos ++;
                    this.limpiarApartadoArchivosFormulario();
                    let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
                    if(camposRequeridos.listaDeArchivos.requerido) {
                        comun.mensajeDeAlerta(`El ${this.textoBotonAgregaraAoV} se agregó correctamente`, null, null);
                    }
                }
            }
            else if(camposRequeridos.listaDeArchivos.requerido){
                comun.mensajeDeAlerta(identificadoresDeArchivo.mensajeError, null, null);
            }
        },
        /**
         * Función encargada de habilitar y setear valores en caso de que se un vinculo a otra pagina.
         */
        eventoOpcionVinculoAotraPagina: function() {
            let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
            if(camposRequeridos.listaDeArchivos.requerido && this.listaDeArchivos.length > 0) {
                this.informarVaciarListaDeArchivos();
            }
            else {
                this.vinculoRadio=true;
                this.descargaRadio=false;
                this.vinculo=null;
                this.textoBotonAgregaraAoV = 'Vinculo';
                this.listaDeArchivos = [];
            }

            this.archivos.mostrarEnVisor = false;
        },
         /**
         * Metodo encargado de obtener el valor del item seleccionado del catalogo submenus
         * @param {object} evento [evento emitido por el catalogo]
         */
        cambioTipoSubmenu: function (evento) {
            this.tipoSubmenuId = parseInt(evento.target.value);
        },
         /**
         * Metodo encargado de obtener el valor del item seleccionado del catalogo de los 3 poderes existentes
         * @param {object} evento [evento emitido por el catalogo]
         */
        cambioCatalogoPoderes: function(evento) {
            this.poderQueDesigna = evento.target.options[evento.target.selectedIndex].text;
        },
        /**
         * Metodo encargado de identificar si se requiere subir archivo con vinculo o directamete desde el inpu
         */
        validarOpcionToggleArchivo: function() {
            let mostrar = false;
            let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
            if(!camposRequeridos.archivoConVinculo.requerido && this.descargaRadio) {
                mostrar = true;
            }
            else if(camposRequeridos.archivoConVinculo.requerido && descargaRadio && descargaArchivoRadio){
                mostrar = true;
            }
            return mostrar;
        },
        /**
         * Metodo encargado de verificar si ya existe un vinculo a otra pagina en el listado
         * @returns {boolean} existeVinculoAotraPagina [variable que representa si ya existe el archivo o no]
         */
        existeVinculoAotraPagina: function() {
            let vinculoAotraPaginaEncontrado = {
                nombreDelVinculo: null,
                existe: false
            };
            if(this.listaDeArchivos.length > 0) {
                this.listaDeArchivos.filter(a => a.NombreEnServidor == 'VinculoPrincipal').forEach(archivo => {
                    vinculoAotraPaginaEncontrado.existe = true;
                    vinculoAotraPaginaEncontrado.nombreDelVinculo = archivo.NombreBase;
                });
            }
            return vinculoAotraPaginaEncontrado;
        },
         /**
         * Metodo encargado de verificar si ya existe un archivo con el mismo nombre 
         * @param {String} nombreDeArchivo [nombre del archivo a comparar]
         * @param {String} esVinculoOarchivo [indica si el elemento que se agregara al listado es vinculo a otra pagina, vinculo de archivo o archivo]
         * @returns {boolean} existeArchivo [variable que representa si ya existe el archivo o no]
         */
        existeUnArchivoConEsteNombre: function(nombreDeArchivo,esVinculoOarchivo) {
            let existeArchivo = false;
            if(this.listaDeArchivos.length > 0 && esVinculoOarchivo != 'VinculoPrincipal') {
                this.listaDeArchivos.filter(a => a.NombreBase == nombreDeArchivo && a.NombreEnServidor != 'VinculoPrincipal').forEach(archivo => {
                    existeArchivo = true;
                });
            }
            return existeArchivo;
        },
        /**
         * Metodo encargado para clasificar si el usario desea cargar un archivos desde el fromulario o cargarlo desde un vinculo
         * para posteriormente contruir el objeto del archivo. 
         * @see {@link agregarArchivoEnListado}
         * @returns {object} identificadoresDeArchivo [objeto con la estructura de la entidad ArchivosDeContenido]
         */
        identificardorTipoRutaArchivo: function() {
            const nombreInicialTipoArchivo = 'Archivo';
            const nombreInicialTipoVinculo = 'Vinculo';
            const nombreInicialTipoVinculoPrincipal = 'VinculoPrincipal';
            let identificadoresDeArchivo = {};
            if(this.vinculoRadio) {
                this.textoVinculoPrincipal = this.vinculo;
                identificadoresDeArchivo.rutaDeArchivo = this.vinculo;
                identificadoresDeArchivo.nombreServidor = nombreInicialTipoVinculoPrincipal;
                identificadoresDeArchivo.mensajeError = 'No has ingresado ningún vinculo a otra pagina,<br>Debes ingresar un vinculo valido a otra pagina';
                identificadoresDeArchivo.nombreBase = this.vinculo;
            }
            else if (this.descargaRadio){
                if(this.vinculoArchivoRadio){
                    identificadoresDeArchivo.rutaDeArchivo = this.vinculo;
                    identificadoresDeArchivo.nombreServidor = nombreInicialTipoVinculo + this.contadorArchivos;
                    identificadoresDeArchivo.mensajeError = 'No has ingresado ningún vinculo para el archivo,<br>Debes ingresar un vinculo para poder agregar el archivo';
                    identificadoresDeArchivo.nombreBase = this.vinculo;
                }
                else {
                    identificadoresDeArchivo.rutaDeArchivo = this.ARCHIVO_DESCARGA;
                    identificadoresDeArchivo.nombreServidor = nombreInicialTipoArchivo + this.contadorArchivos;
                    identificadoresDeArchivo.mensajeError = 'No hay ningún archivo seleccionado,<br>Debes tener un archivo seleccionado para poder agregar el archivo';
                    identificadoresDeArchivo.nombreBase = this.campoEsValidoFormulario(this.ARCHIVO_DESCARGA) ? this.ARCHIVO_DESCARGA.name : null;
                    identificadoresDeArchivo.mostrarEnVisor = this.archivos.mostrarEnVisor;
                }
            }
            return identificadoresDeArchivo;
        },
         /**
         * Metodo encargado para limpiar las variables relacionadas con el apartado de archivos dentro del fromulario.  
         */
        limpiarApartadoArchivosFormulario: function() {
            let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
            if(camposRequeridos.listaDeArchivos.requerido ) {
                 $("#descarga_contenido").val('');
                 this.ARCHIVO_DESCARGA = null;
                 this.tituloArchivo = null;
                 this.vinculo = null;
                 this.textoVinculoArchivo = null;
            }
        },
         /**
         * Metodo encargado de remover items de la lista de archivos.
         * @param {object} evento [evento emitido por el icono de eliminar dentro de la tabla correspondiente al listado de archivos]
         */
        removerArchivoDeLista: function(evento) {
            let llaveArchivo = evento.target.getAttribute('id');
            const indexDeElemento = this.listaDeArchivos.findIndex(archivo => archivo.NombreEnServidor == llaveArchivo);
            if(indexDeElemento > -1) {
                this.listaDeArchivos.splice(indexDeElemento, 1);
                delete this.listaDeArchivosBit[llaveArchivo];
                if(this.listaDeArchivos.length < 1){
                    this.existePerdidaDeCambios = false;
                }
            }
        },
         /**
         * Metodo encargado de remover todos los items de la lista de archivo y reiniciar el contador.
         */
        vaciarListaArchivosAgregados: function() {
            this.listaDeArchivos = [];
            this.contadorArchivos = 0;
            this.listaDeArchivosBit = new Object();
            this.existePerdidaDeCambios = false;
        },
        /**
         * Metodo encargado de regresar al paso uno, validando previamente si el usuario no a guardado cambios dentro del formulario y
         * llamando al API para cambiar el estatus enEdicion de la saccion a false (no se esta editando).
         */
        cambioDeSeccion: function() {
            this.validarFormulario(null);
            if(this.existePerdidaDeCambios && this.modificoOrdenDeContenidos)
            {
                this.informarPerdidaDeCambiosEnFormularioYOrden();
            }
            else if(this.existePerdidaDeCambios || this.listaDeArchivos.length > 0) 
            {
                this.informarPerdidaDeCambiosFormularioContenido();
            }
            else if(this.modificoOrdenDeContenidos)
            {
                this.informarPerdidaDeCambiosOrdenContenidos(false);
            }
            else 
            {
                this.cambiarEstatusSeccion(false);
            }
        },
        /**
         * Metodo encargado de ocultar componente correspondiente al paso dos.
         */
        ocultarPasoDos: function() {
            $("#contenedor-pasoUno").removeClass("desabilitar-div-pasoUno");
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarFormularios",false);
            this.limpiarFormulario();
        },
        /**
         * Metodo encargado validar si el contenido requiere textoDelVinculo.
         * @returns {boolean} mostrar [variable que representa si se debe mostrar el campo dentro del formulario]
         */
        mostrarTextoDelVinculo: function() {
            let mostrar = true;
            const PAGINA_WEB_CONVOCATORIA = 3;
            const PAGINA_WEB_BOLETIN_ELECTRONICO = 29;
            let idPaginaWebSeleccionada  = this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb.catalogoPaginaPasoUno;
            if(this.obtenerCamposRequeridosEnFormulario.tipoDeFormulario == 'comunicado' || (idPaginaWebSeleccionada == PAGINA_WEB_CONVOCATORIA || idPaginaWebSeleccionada == PAGINA_WEB_BOLETIN_ELECTRONICO)) {
                mostrar = false;
            }
            return mostrar;
        },
         /**
         * Metodo encargado de agregar contenido en base de datos valida previamente la existencia de perdida de cambios
         * en la pestaña Modificar orden del contenido. 
         * @see {@link informarPerdidaDeCambiosOrdenContenidos}
         * @see {@link agregarContenidoBD}
         */
        agregarContenido: function() {
            if(this.modificoOrdenDeContenidos)
                this.informarPerdidaDeCambiosOrdenContenidos(true);
            else
                this.agregarContenidoBD();
        },
         /**
         * Metodo encargado de llamar a la API para guardar contenido en base de datos. 
         */
        agregarContenidoBD: function() {
            // se validan los campos del formulario
            let noticiaUrgente = this.urgenteRadio;
            let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
            /* 03/07/2020 no actualiza archivo if(!camposRequeridos.listaDeArchivos.requerido && this.listaDeArchivos < 1) { */
            if(!camposRequeridos.listaDeArchivos.requerido) {
                this.listaDeArchivos = [];
                this.agregarArchivosAcontenido();
            }
            else {
                this.textoVinculoPrincipal = this.vinculo;
            }
            if(this.validarFormulario(noticiaUrgente)) {
                if(this.validacionesEspecificasParaInput()) { 
                    comun.SeEstaCargandoInformacion(true);
                    // definimos metodo de API
                    const SERVIDOR = api.conexion;
                    /* const METODO_API_AGREGAR = api.SICPO.funcion.AltaDeContenidoDePaginaWeb; */
                    const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.altadecontenido.AltaDeContenidoDePaginaWeb;
                    let urlApi = SERVIDOR + METODO_API_AGREGAR;
                    // craeamos la peticion con el formulario
                    let peticionAPI = this.crearPeticion();
                    let peticionArchivos = true;
                    let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
                    comun.SeEstaCargandoInformacion(true);
                    axios.post(urlApi, peticionAPI, headerPeticion)
                            .then(respuesta => {            
                                if (respuesta.data.SiHayError) {
                                    console.log(respuesta);
                                    let mensajeError = respuesta.data.Error.Mensaje;
                                    this.informarError(mensajeError);
                                } else {
                                    this.limpiarFormulario();
                                    this.obtenerListadoDeContenidos();
                                    this.mostrarErroresInput = false;
                                    $("#ordenar-tab").removeClass("disabled");
                                    this.$emit('ocultarTooltip','disable');
                                    this.sobreescribirArchivo = false;
                                    comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                                }
                                comun.SeEstaCargandoInformacion(false);
                            })
                            .catch(excepcion => {
                                comun.SeEstaCargandoInformacion(false);
                                console.log(excepcion);
                                this.informarError(excepcion.message);
                            }
                    ); 
                } 
            }
            else {
                 comun.mensajeDeAlerta(this.textoMensajeCampoFaltante, null, null);
                 this.mostrarErroresInput = true;
                 this.textoMensajeCampoFaltante = '';
                 this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormulario",false);
            }
        },
        /**
         * Metodo hacer el llamado a API para cambiar el estatus de la sección. 
         * @param {bool} enEdicion [estatus de seccion]
         */
        cambiarEstatusSeccion:function(enEdicion){
             // definimos metodo de API
            const SERVIDOR = api.conexion;
            const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.altadecontenido.ModificarEstatusDeSeccion;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            // craeamos la peticion con el formulario 
            let peticionAPI = {
                SeccionDeLaPaginaWebId: this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_punteroDeContenidoActual.seccionCrearContenidoId,
                EnEdicion: enEdicion,
                EsPrueba: false
            }
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(respuesta);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } else {
                            this.ocultarPasoDos();
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    }
            ); 
        },
         /**
         * Metodo encargado para clasificar errores arrojados por excepciones y posteriormente informarlo al usuario. 
         * @param {String} error [mensaje de la excepcion capturada]
         */
        informarError: function(error) {
            //console.log('informarError' + error)
            switch(error){
                case 'Network Error':
                    this.manejoErrorArchivoNoEncontrado();
                    break;
                case 'Ya existe el archivo de descarga seleccionado':
                    this.informarSobreescrituraDeArchivos(error);
                    break;
                case 'Ya existe la imagen del comunicado seleccionada':
                    this.informarSobreescrituraDeArchivos(error);
                    break;
                default:
                    comun.mensajeDeAlerta(error, null, null);
                    break;
            }
        },
         /**
         * Metodo encargado para manejar el error FileNotFound en navegador. 
         */
        manejoErrorArchivoNoEncontrado: function() {
            const mensajeErrorImagen = 'La imagen o el archivo de descarga que ha seleccionado para subir no se encuentra en la ruta especificada. Verifique que dichos archivos sigan existiendo en su lugar e intentelo de nuevo.';
            const mensajeErrorArchivoDescarga = 'El archivo de descarga que ha seleccionado para subir no se encuentra en la ruta especificada. Verifique que el archivo siga existiendo en su lugar e intentelo de nuevo.';
            if(this.obtenerCamposRequeridosEnFormulario.tipoDeFormulario == 'comunicado') {
                comun.mensajeDeAlerta(mensajeErrorImagen, null, null);  
            }
            else {
                comun.mensajeDeAlerta(mensajeErrorArchivoDescarga, null, null);
            }
        },
         /**
         * Metodo encargado para asignar valor de input correspondiente a la imagen a la variable IMAGEN_CONTENIDO que 
         * posteriormente se enviara en la peticon para el alta de contenido. 
         * @param {object} evento [evento emitido por el input tipo file correspondiente a la imagen]
         */
        subirImagen: function(evento) {
            try{
                if(evento.target.files.length > 0) {
                    const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
                    if(this.verificaQueSeaElDocumentoCorrecto(NOMBRE_DE_ARCHIVO,'IMAGEN')) {
                        this.IMAGEN_CONTENIDO = evento.target.files[0];
                        this.mostrarSubidorDeArchivos = true;
                    }
                    else {
                        $("#imagen_contenido").val('');
                        this.IMAGEN_CONTENIDO = null;
                        comun.mensajeDeAlerta('Para las imagenes solo se permiten extensiones JPEG,JPG y PNG,<br>Seleccione otra imagen con una de las siguientes extensiones JPEG,JPG o PNG');
                    }
                }
                else {
                    this.IMAGEN_CONTENIDO = null;
                    this.mostrarSubidorDeArchivos = false; 
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
         /**
         * Metodo encargado para asignar valor de input correspondiente para archivo hacia la variable ARCHIVO_DESCARGA que 
         * posteriormente se enviara en la peticon para el alta de contenido. 
         * @param {object} evento [evento emitido por el input tipo file correspondiente al archivo]
         */
        subirArchivoDescarga: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
                    if(this.verificaQueSeaElDocumentoCorrecto(NOMBRE_DE_ARCHIVO,'DESCARGA')) {
                        this.ARCHIVO_DESCARGA = evento.target.files[0];
                        this.mostrarSubidorDeArchivos = true;
                    }
                    else {
                        $("#descarga_contenido").val('');
                        this.ARCHIVO_DESCARGA = null;
                        comun.mensajeDeAlerta('Para los archivos de descarga solo se permiten extensiones PDF,XLSX,XLSB y ZIP,<br>Seleccione otro archivo con una de las siguientes extensiones PDF,XLSX,XLSB o ZIP');
                    }
                }
                else {
                    this.ARCHIVO_DESCARGA = null;
                    this.mostrarSubidorDeArchivos = false;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        verificaQueSeaElDocumentoCorrecto: function(nombreArchivo,tipoDocumento) {
            const NOMBRE_CORTADO = nombreArchivo.split(".");
            let siEsUnDocumentoValido = false;
            switch(tipoDocumento) {
                case 'DESCARGA':
                    const EXTENSION_ARCHIVO = NOMBRE_CORTADO[NOMBRE_CORTADO.length - 1].toUpperCase();
                    if(EXTENSION_ARCHIVO === 'PDF' || EXTENSION_ARCHIVO === 'XLSX' || EXTENSION_ARCHIVO === 'XLSB' || EXTENSION_ARCHIVO === 'ZIP')
                        siEsUnDocumentoValido = true;

                    break;
                case 'IMAGEN':
                    const EXTENSION_IMAGEN = NOMBRE_CORTADO[NOMBRE_CORTADO.length - 1].toUpperCase();
                    if(EXTENSION_IMAGEN === 'JPEG' || EXTENSION_IMAGEN === 'JPG' || EXTENSION_IMAGEN === 'PNG')
                        siEsUnDocumentoValido = true;
                        
                    break;
                default:
            }
            return siEsUnDocumentoValido;
        },
        obtenerListaDeImagenesObligaciones: function() {
            let listaImagenes = null;
            // definimos metodo de API
            const SERVIDOR = api.conexion;
            const METODO_API_AGREGAR = api.SICPO.catalogos.C021ImagenesPredeterminadas;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let seccionId = this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_punteroDeContenidoActual.seccionCrearContenidoId;
            let peticionMetodoGetImagenesPredeterminadasAPI = {
                ImagenPredeterminadaId: null,
                SeccionDeLaPaginaWebId: seccionId,
                ConSeccionesDeLaPaginaWeb: false,
                ConInactivos: false,
                ConRutasParaAccesoDesdeFront:true
            }
            peticionMetodoGetImagenesPredeterminadasAPI.EsPrueba = this.enumeraciones.EsPrueba;
            // contruir header de la peticion
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);

            axios.post(urlApi, peticionMetodoGetImagenesPredeterminadasAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            console.log(respuesta); 
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        } else {
                            listaImagenes = respuesta.data.ImagenesPredeterminadas;
                            this.listadoImagenesObligaciones = this.transformarImagenesPredeterminadasParaCatalogo(listaImagenes);
                        }
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                    }
            ) // axios.post
        },
        transformarImagenesPredeterminadasParaCatalogo: function(listaImagenes) {
            let ListadoImagenesPredeterminadas = [];
            if(listaImagenes != null && listaImagenes.length > 0) {
                listaImagenes.forEach((img)=>{
                    let objImg = {
                        llave: img.ImagenPredeterminadaId,
                        imagen: img.RutaDeLaImagen
                    }
                    ListadoImagenesPredeterminadas.push(objImg);
                });
            }
            return ListadoImagenesPredeterminadas;
        },
         /**
         * Metodo encargado de crear la peticion para el alta de contenido, haciendo una iterando la lisa de archivos
         * para enviarlos como parametros independientes posteriormente se agrega a un objeto con la estructura de la
         * entidad de contenido finalmente se convierte el objeto contenido a JSON y se agrega como parametro. 
         */
        crearPeticion: function() { debugger
            let datosDelFormulario = new FormData();
            let seccionId = this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_punteroDeContenidoActual.seccionCrearContenidoId;
            let paginaId  = this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb.catalogoPaginaPasoUno;
            let esComunicado = this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario.tipoDeFormulario == 'comunicado'? true : false;
            
            let contenido = {};
            let esSeccion = (seccionId == 3) ? true : false;
            contenido.TextoDelContenido = this.construirDescripcionContenido(paginaId,esSeccion);
            this.construirTextoDelVinculoContenido();
            contenido.TextoDelVinculo = this.textoVinculo;
            contenido.Vinculo = this.textoVinculoPrincipal
            contenido.FechaDePublicacion = this.fechaDatePickerInicio;
            contenido.ArchivosDeContenidoDeLaPaginaWeb = [];
            // valores para entidad comunicado 
            contenido.Titulo = this.titulo;
            let llaveImagen = this.IMAGEN_CONTENIDO !=null ? 'ImagenComunicado': this.imagenDeObligacion;
            contenido.RutaDeImagen = llaveImagen;
            contenido.EsUrgente = this.urgenteRadio;
            contenido.FechaDePublicacionFinal = this.fechaDatePickerfinal; 
            contenido.EsDisposicionEspecial = this.disposicionEspecial || paginaId == 28;
            contenido.tipoIcono = null;
            let submenu = null;
            contenido.subMenu = submenu;
            contenido.esPin = this.esPin;
           if(this.descargaRadio) {
                this.listaDeArchivos = this.listaDeArchivos.filter(a => a.NombreEnServidor != 'VinculoPrincipal');
                this.listaDeArchivos.filter(a => a.NombreEnServidor.includes('Archivo')).forEach(archivo => {
                    datosDelFormulario.append(archivo.NombreEnServidor,this.listaDeArchivosBit[archivo.NombreEnServidor]);
                    archivo.RutaDelArchivo = '';
                    archivo.Titulo = (archivo.Titulo == 'Sin título') ? null : archivo.Titulo;
                    archivo.TextoDelVinculo = (archivo.TextoDelVinculo == 'Sin texto de vínculo') ? null : archivo.TextoDelVinculo;
                });
                contenido.ArchivosDeContenidoDeLaPaginaWeb = this.listaDeArchivos;
            }
            if(this.IMAGEN_CONTENIDO !=null)
                datosDelFormulario.append(llaveImagen,this.IMAGEN_CONTENIDO);
            let contenidoJSON = JSON.stringify(contenido);
            datosDelFormulario.append('Contenido',contenidoJSON); 
            datosDelFormulario.append('PaginaWebId',paginaId);
            datosDelFormulario.append('SeccionId',seccionId);
            datosDelFormulario.append('EsComunicado', esComunicado);
            datosDelFormulario.append('EsPrueba',false);
            let submenuId = (this.disposicionEspecial) ? this.tipoSubmenuId : -1;
            datosDelFormulario.append('SubmenuId',submenuId);
            datosDelFormulario.append('SubmenuTitulo',this.textoTituloSubmenu);
            return datosDelFormulario;
        },
        /**
         * Metodo encargado de contruir el campo contenido segun lo requiera el 
         * tipo de pagina
         */
        construirDescripcionContenido: function(tipoDePagina,esSeccion) {
            let textoContenido = this.textoDelContenido;
            let contenido = [];
            switch(true) {
                // pagina web tipo presidentes
                case tipoDePagina == 12:
                    contenido.push(this.nombrePresidente);
                    contenido.push(this.rangoPresidente);
                    textoContenido = contenido.join("¶");
                    break;
                // paginas web Magistrados del supremo tribunal de justicia y Magistrados de sala administrativa 
                case (tipoDePagina == 4 || tipoDePagina == 6):
                    const ENCABEZADO_CONTENIDO = 'Síntesis Curricular.' + "\n";
                    contenido.push(this.nombrePresidente);
                    this.textoVinculo = this.nombrePresidente;
                    contenido.push(ENCABEZADO_CONTENIDO);
                    contenido.push(this.textoDelContenido);
                    textoContenido = contenido.join("\n");
                    break;
                // en este caso se trata de una seccion consejero
                case (esSeccion && tipoDePagina == 2):
                     contenido.push(this.nombrePresidente);
                     let poderQuedesinaStr = this.poderQueDesigna;
                     if(this.esSuplente){
                         poderQuedesinaStr += ' (Suplente)'
                     }
                     contenido.push(poderQuedesinaStr);
                     textoContenido = contenido.join("¶");
                    break;
                default:
            }
            return textoContenido;
        },
        /**
         * Metodo encargado de contruir el campo textoDelVinculo segun lo requiera el 
         * tipo de contenido
         */
        construirTextoDelVinculoContenido: function() {
            if(this.textoVinculo == null || this.textoVinculo == '') {
                if(this.vinculoRadio) {
                    this.listaDeArchivos.filter(a => a.NombreEnServidor == 'VinculoPrincipal').forEach(vinculo => {
                        this.textoVinculo = vinculo.TextoDelVinculo;
                    });
                }
            }
        },
         /**
         * Metodo encargado de inicializar el formulario (limpiar los input y variables ralcionadas con logica de alta de contenido). 
         */
        inicializarFormulario: function() {
            this.limpiarFormulario();
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormularioInput",false);
        },
        /**
         * Metodo encargado de limpiar cada una de las variables relacionadas con el formulario de alta de contenido. 
         */
        limpiarFormulario: function() {
            this.titulo = '';
            this.vinculo = null;
            this.textoDelContenido = null;
            this.textoVinculo = null;
            $("#imagen_contenido").val('');
            $("#descarga_contenido").val('');
            this.IMAGEN_CONTENIDO = null;
            this.ARCHIVO_DESCARGA = null;
            this.fechaDePublicacion = '';
            this.fechaDePublicacionFin = '';
            this.limpiarOpcionesToggle();
            if(this.urgenteRadio) {
                this.urgenteRadio = true;
                this.informativoRadio = false;
            }
            else {
                this.urgenteRadio = false;
                this.informativoRadio = true;
            }
            this.listaDeArchivos = [];
            this.contadorArchivos = 0;
            this.textoVinculoArchivo = null;
            this.nombrePresidente = null;
            this.rangoPresidente = null;
            this.vinculoArchivo = false;
            this.textoBotonAgregaraAoV = 'Archivo'
            this.textoVinculoPrincipal = null;
            this.disposicionEspecial = false;
            this.esPin = false;
            this.textoTituloSubmenu = null;
            this.fechaDatePickerInicio = new Date();
            this.fechaDatePickerfinal= new Date();
            this.tipoSubmenuId = -1;
            this.esSuplente = false;
            $('#' + this.imagenDeObligacion).prop('checked', false);
            this.imagenDeObligacion = null;
            $("#catalogo-poderes-pasoDos option:first").prop("selected", "selected");
            this.archivos.mostrarEnVisor = false;
        },
        /**
         * Metodo encargado de reiniciar los valores para las opciones toggle correspondientes al manejo de archivos 
         * y vinculos a otras paginas
         */
        limpiarOpcionesToggle: function() {
            if(this.descargaRadio) {
                this.vinculoRadio = false;
                if(this.descargaArchivoRadio) {
                    this.vinculoArchivoRadio = false;
                }
                else if(this.vinculoArchivoRadio) {
                     this.descargaArchivoRadio = false;
                }
            }
            else if(this.vinculoRadio) {
                this.descargaRadio = false;
                this.descargaArchivoRadio = true;
                this.vinculoArchivoRadio = false;
            }
        },
        /**
         * Metodo encargado de actualizar y recuperar el valor de existePerdidaDeCambios.  
         * @returns {boolean} existePerdidaDeCambios [representa si el formulario tiene información o no]
         */
        obtenerExistePerdidaDeCambios: function()
        {
            this.validarFormulario(null);
            return this.existePerdidaDeCambios;
        },
        /**
         * Metodo encargado de validar que los campos requeridos por el formulario no estan vacion o contengan datos incorrectos.  
         * @param {any} tipoDeFormulario [indicador para clasificar el tipo de formulario]
         * @returns {boolean} formularioValido [representa si el formulario es valido o no]
         */
        validarFormulario: function(tipoDeFormulario) { 
            let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
            let camposAvalidar = [];
            let formularioValido = true;
            let input = {};
            let paginaWebId = this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb.catalogoPaginaPasoUno;

            if(camposRequeridos.titulo.requerido) {
                input = {
                    campo: this.titulo,
                    mensaje: 'el título'
                }
                camposAvalidar.push(input)
            }
            if(camposRequeridos.nombrePresidente.requerido) {
                input = {
                    campo: this.nombrePresidente,
                    mensaje: ' el nombre del presidente'
                }
                camposAvalidar.push(input); 
            }
            if(camposRequeridos.rangoPresidente.requerido) {
                input = {
                    campo: this.rangoPresidente,
                    mensaje: ' el periodo de tiempo en que fue presidente'
                }
                camposAvalidar.push(input); 
            }
            if(camposRequeridos.textoDelContenido.requerido) {
                input = {
                    campo: this.textoDelContenido,
                    mensaje: ' la descripción del contenido'
                }
                camposAvalidar.push(input); 
            }
            if(camposRequeridos.imagenDeContenido.requerido) {
                 input = {
                    campo: this.IMAGEN_CONTENIDO,
                    mensaje: ' la imagen del contenido'
                 }
                camposAvalidar.push(input);
            }
            if(camposRequeridos.imagenesObligaciones.requerido){
                input = {
                    campo: this.imagenDeObligacion,
                    mensaje: ' la imagen de la obligacion'
                 }
                camposAvalidar.push(input);
            }
            if(camposRequeridos.archivosDeContenido.requerido) {
                if(camposRequeridos.listaDeArchivos.requerido) {
                    if(this.listaDeArchivos.length < 1 && this.descargaRadio) {
                            let mensajaArchivoVacio = ' el archivo de descarga, debes agregarlo primero';
                            let mensajeVinculoVacio = ' el vínculo del archivo, debes agregarlo primero';
                            let mensajeAlerta = (this.descargaArchivoRadio) ? mensajaArchivoVacio : mensajeVinculoVacio;
                            input = {
                                campo: null,
                                mensaje: mensajeAlerta
                            }
                            camposAvalidar.push(input);
                    }
                    else if(this.vinculoRadio){
                        input = {
                            campo: this.vinculo,
                            mensaje: ' el vinculo de la pagina'
                        }
                        camposAvalidar.push(input);
                    }
                } // lista de archivos requerido
                else {
                    if(this.descargaRadio) {
                        input = {
                            campo: this.ARCHIVO_DESCARGA,
                            mensaje: ' el archivo de descarga'
                        }
                        camposAvalidar.push(input);
                    }
                    if(this.vinculoRadio) {
                        input = {
                            campo: this.vinculo,
                            mensaje: ' el vinculo de la pagina'
                        }
                        camposAvalidar.push(input);
                    }
                }
            } // con archivo requerido
            if(this.disposicionEspecial) {
                input = {
                    campo: this.tipoSubmenuId,
                    mensaje: ' El tipo de submenu.'
                }
                camposAvalidar.push(input);

                input = {
                    campo: this.textoTituloSubmenu,
                    mensaje: ' El titulo de la disposicion especial.'
                }
                camposAvalidar.push(input);
            }
            camposAvalidar.push(input);
            formularioValido = this.validarCamposFormulario(camposAvalidar);
            return formularioValido;
        },
        validacionesEspecificasParaInput: function() {
            let validacionesRealizadas = true;
            if(this.vinculoRadio){
                let vinculoValido = this.validarVinculoURL(this.vinculo);
                if(!vinculoValido)
                    return vinculoValido;
            }
            return validacionesRealizadas;
        },
        validarVinculoURL: function(vinculo) {
            let pattern = new RegExp('^(https?:\\/\\/)?'+ // protocolo
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // nombre del dominio
                '((\\d{1,3}\\.){3}\\d{1,3}))'+ // ip
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // puerto y ruta
                '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query de la peticion
                '(\\#[-a-z\\d_]*)?$','i'); // localizador de fragmentos
            let vinculoValido = !!pattern.test(vinculo);
            if(!vinculoValido)
                comun.mensajeDeAlerta('El vinculo no es valido,<br> por favor ingrese un vinculo valido, ejemplo www.vinculoPrueba.com');

            return vinculoValido;
        },
        /**
         * Metodo encargado de obtener la fecha actual con el formato [yyyy-mm-dd]
         */
        obtenerFecha: function(fecha) {
            let fechaActual = fecha;
            let mes = '' + (fechaActual.getMonth() + 1);
            let dia = '' + fechaActual.getDate();
            let year = fechaActual.getFullYear();

            if (mes.length < 2) 
                mes = '0' + mes;
            if (dia.length < 2) 
                dia = '0' + dia;

            return [year, mes, dia].join('-');
        },
        /**
         * Metodo encargado de validar los input correspondientes a fechas
         * fecha de publicación inicial >= fecha actual &&  fecha de publicación inicial < fecha de publicación final
         * fecha de publicación final > fecha de publicación inicial && fecha de publicación final > fecha actual
         */
        validarFechas: function() {
            let fechaValida = false;
            let fechaActual = this.obtenerFecha(new Date());
            let mensajeError = ['La fecha de publicación inicial no puede ser menor a la fecha actual, <br> por favor ingrese una fecha de publicación inicial valida'];
            
            if(this.fechaDePublicacion >= fechaActual) {
                fechaValida = true;
                mensajeError.pop();
            }
            if(this.urgenteRadio) {
                if(fechaValida && this.fechaDePublicacion < this.fechaDePublicacionFin) {
                    if(this.fechaDePublicacionFin > fechaActual) {
                         fechaValida = true;
                    }
                    else {
                        fechaValida = false;
                        mensajeError.push('La fecha final de publicacion no puede ser menor a la fecha actual, <br> por favor ingrese una fecha final de publicacion valida');
                    }
                }
                else {
                    fechaValida = false;
                    mensajeError.push('La fecha de publicacion inicial no puede ser mayor o igual a la fecha fin de la publicacion, <br> por favor ingrese una fecha de publicacion inicial valida');
                }
            }

            if(!fechaValida){
                comun.mensajeDeAlerta(mensajeError[0]);
            }
            return fechaValida;
        },
        /**
         * Metodo encargado de iterar lista de campos requridos por el formulario para posteriormente validar cada uno de los valores.  
         * @param {array} datosFormulario [arreglo compuesto de los capos requeridos por el formulario]
         * @returns {boolean} camposValidos [indica si los elementos de la lista de campos requeridos son validos]
         */
        validarCamposFormulario: function(datosFormulario) {
            let camposValidos = true;
            let existeValorIncorrecto = false;
            this.existePerdidaDeCambios = false;
            for (let i=0; i<datosFormulario.length; i++ ) {
                if(!existeValorIncorrecto){
                    camposValidos = this.campoEsValido(datosFormulario[i]);
                    if(!camposValidos){
                        existeValorIncorrecto = true;
                    }
                    else{
                        this.existePerdidaDeCambios = true;
                    }
                }
                else {
                    let resultadoTemporal = this.campoEsValido(datosFormulario[i]);
                    this.existePerdidaDeCambios = resultadoTemporal ? resultadoTemporal : this.existePerdidaDeCambios;
                }
            }
            return camposValidos;
        },
         /**
         * Metodo encargado de comparar si un valor del formulario esta vacio y si es obligatorio se asigna el valor del
         * mensaje que se mostrara al ususario en base al orden de los campos previamente establecidos.  
         * @param {any} input [valor a comparar]
         * @returns {boolean} campoValido [indica si el valor comparado esta vacio o no]
         */
        campoEsValido: function(input) {
            let campoValido = true;
            if(!this.campoEsValidoFormulario(input.campo)) {
                campoValido = false;
                if(this.textoMensajeCampoFaltante =='')
                    this.textoMensajeCampoFaltante = 'Se detectaron campos vacios, favor de ingresar ' + input.mensaje + '.';
            }
            else if(this.textoMensajeCampoFaltante.includes(input.mensaje)) this.textoMensajeCampoFaltante = '';
            return campoValido;
        },
        /**
         * Metodo encargado de comparar si un valor esta vacio.  
         * @param {any} campo [valor a comparar]
         * @returns {boolean} campoValido [indica si el valor comparado esta vacio o no]
         */
        campoEsValidoFormulario: function(campo) {
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        noHacerNada: function() {
            
        },
         /**
         * Metodo encargado de craer la peticion para obtener listado de contenidos de la base de datos.  
         * @returns {object} peticion [objeto con la estructura requerida para el consumo del metodo GET correspondiente del API]
         */
        crearPeticionListadoDeContenido: function() {
            let seccionId = this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_punteroDeContenidoActual.seccionCrearContenidoId;
            let paginaId  = this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb.catalogoPaginaPasoUno;
            let esComunicado = this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario.tipoDeFormulario == 'comunicado'? true : false;
            let peticion = {
                PaginaWebId: paginaId,
                SeccionDeLaPaginaWebId: seccionId,
                EsComunicado: esComunicado
            }
            return peticion;
        },
        /**
         * Metodo de lamar a la API para obtener listado de contenidos.  
         */
        obtenerListadoDeContenidos: function() {
            // definimos metodo de API
            const SERVIDOR = api.conexion;
            /* const METODO_API_AGREGAR = api.SICPO.funcion.ContenidosDeLaPaginaWeb; */
            const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.altadecontenido.ContenidosDeLaPaginaWeb;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            // creamos la peticion con el formulario
            let peticionAPI = this.crearPeticionListadoDeContenido();
            // contruir header de la peticion
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            console.log(respuesta); 
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        } else {
                            let listaDeCotenidosOriginal = [];
                            let comunicadosDePaginaWeb   = respuesta.data.ComunicadosDePaginaWeb;
                            let contenidosDePaginaWeb    = respuesta.data.ContenidosDeLaPaginaWeb;
                            if(contenidosDePaginaWeb.length > 0) {
                                listaDeCotenidosOriginal = contenidosDePaginaWeb;
                            }
                            else {
                                listaDeCotenidosOriginal = comunicadosDePaginaWeb;
                            }
                            this.mapearInformacionParaListado(listaDeCotenidosOriginal);
                        }
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                    }
            ) // axios.post
        },
        /**
         * Metodo encargado de mapear el listado de contenidos obtenido por la API en un nuevo listado con la 
         * estructura requerida() para mostrar el listado en la pestaña modificar orden de contenido.
         * @see ListaOrdenableDeContenido.vue  
         * @param {array} listado [lista de contenidos]
         */
        mapearInformacionParaListado: function(listado) {
            let listaContenidosOriginal = [];
            var urgenteVisibleId = -1;
            let hoy = new Date();
            let esComunicado = this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario.tipoDeFormulario == 'comunicado' ? true : false;
            let esBoletinElectronicoOInformeLaboral = this.obtenerPaginaWebId == 29 || this.obtenerPaginaWebId == 1;
            for(var i=0;i<listado.length;i++){
                let icoMostrar =  (i < 3 && esComunicado? true: false) || (i==0 && esBoletinElectronicoOInformeLaboral);
                if( esComunicado &&
                    listado[i].EsUrgente &&
                    (new Date(listado[i].FechaDePublicacion) <= hoy && new Date(listado[i].FechaDePublicacionFinal) >= hoy))
                {
                    if(urgenteVisibleId != -1)
                        urgenteVisibleId = listado[urgenteVisibleId].FechaDeRegistro > listado[i].FechaDeRegistro? 
                                            urgenteVisibleId : i;
                    else urgenteVisibleId = i; 
                }

                let elementoContenido = {
                    id: i, 
                    mostrarDescripcion:false, 
                    hover:false,
                    conIconoUrgenteVisible: false,
                    conIconoMostrarEnInicio: icoMostrar,
                    contenido: listado[i]
                }
                listaContenidosOriginal.push(elementoContenido);
            }
            if(esComunicado && urgenteVisibleId!=-1)
                listaContenidosOriginal[urgenteVisibleId].conIconoUrgenteVisible = true;
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerListaContenidoOriginal",listaContenidosOriginal);
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar  posible perdida de cambios. 
         * @param {bool} guardarContenido [Si se quiere guardar contenido o cambiar seccion]
         * @see {@link agregarContenidoDB}
         * @see {@link cambiarEstatusSeccion}
         */
        informarPerdidaDeCambiosOrdenContenidos: function (guardarContenido) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Se detectaron cambios en la pestaña 'Modificar Orden de Contenidos', si deseas continuar " + (guardarContenido? "y cambiar de sección " : "") + "se perderán los cambios que no han sido guardados<br>¿Desea continuar?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        if(guardarContenido)
                        {
                            this.agregarContenidoBD();
                            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                        }
                        else{
                            this.cambiarEstatusSeccion(false);
                            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                        }
                    }
                }
            });
        },
        /**
         * Metodo encargado de mostrar alerta bootbox para informar  posible perdida de cambios.
         * @see {@link cambiarEstatusSeccion}
         */
        informarPerdidaDeCambiosEnFormularioYOrden: function () {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Has ingresado información en la pestaña de 'Agregar Contenido' y se detectaron cambios en la pestaña 'Modificar Orden de Contenidos', si deseas continuar y cambiar de sección se perderán los cambios que no fueron guardados<br>¿Desea continuar?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.cambiarEstatusSeccion(false);
                        this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                    }
                }
            });
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para acerca de sobreescritura de archivos. 
         * @param {string} mensajeR [mensaje que se quiera mostrar en alert]
         */
        informarSobreescrituraDeArchivos: function (mensajeR) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: mensajeR + ",<br> ¿deseas sobreescribir el archivo?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.sobreescribirArchivo = true;
                        this.agregarContenidoBD();
                        this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                    }
                }
            });
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar que se removera un elemento de la lista de archivos. 
         * @param {object} evento [evento emitido por el item de la tabla de archivos]
         */
        informarSacarArchivoDeLista: function(evento) {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:"Se eliminara el archivo de la lista,<br>¿Estas seguro de eliminar el archivo?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.removerArchivoDeLista(evento);
                    }
                }
            });
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar que se agrego un elemento a la lista de archivos. 
         */
        informarVaciarListaDeArchivosAgregados: function() {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:"Se eliminaran todos los archivos,<br>¿Estas seguro de eliminar todos los archivo?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.vaciarListaArchivosAgregados();
                    }
                }
            });
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar que existe la posibilidad de perdida de cambios.
         * @see {@link cambiarEstatusSeccion} 
         */
        informarPerdidaDeCambiosFormularioContenido: function () {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Has ingresado información en la pestaña de 'Agregar Contenido', si deseas continuar y cambiar de sección se perderán los cambios que no han sido guardados<br>¿Desea continuar?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                         this.cambiarEstatusSeccion(false);
                    }
                }
            });
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar que se vaciara la lista de archivos (en caso de manejar listado y cambiar de opcion toggle vinculo a otra pagina)
         */
        informarVaciarListaDeArchivos: function() {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:"Si cambias a la opcion vinculo a otra pagina se borraran los archivos que has agregado,<br>¿Estas seguro de cambiar a la opcion vinculo a otra pagina?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.listaDeArchivos = [];
                        this.vinculoRadio=true;
                        this.descargaRadio=false;
                        this.vinculo=null;
                        this.textoBotonAgregaraAoV = 'Vinculo';
                    }
                    else {
                        $("#vinculoRadio-toggle").removeClass('active');
                        $("#descargaRadio-toggle").addClass('active');
                    }
                }
            });
        },
    },
    created() {
        this.obtenerListaDeImagenesObligaciones();
    },
    computed: {
        obtenerTipoDeFormulario() {
             return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_tipoDeFormulario;
        },
        mostrarErrorEnInput() {
            return this.mostrarErroresInput;
        },
        obtenerCambiarFormulario() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_cambioDeFormulario;
        },
        obtenerInicializarFormulario() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_cambioDeFormularioInput;
        },
        obtenerCamposRequeridosEnFormulario() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario;
        },
        obtenerListadoInicial() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_listaContenidoOriginal;
        },
        modificoOrdenDeContenidos() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_cambioOrdenlistaContenidos;
        },
        obtenerPaginaWebId() {
            return this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb.catalogoPaginaPasoUno;
        },
        obtenerPunterosParaContenido() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_punteroDeContenidoActual;
        }
    }
}
</script>
<style  scoped>
    .btn-primary{
        background-color: var(--verde-pj);
    }

    .btn-primary:hover{
        background-color: var(--verde-pj-100);
    }
    .container-btn {
        display: flex;                             
        justify-content: space-between; 
    }
    h5, h6{
        user-select: none;
    }
    .btn-group-toggle{
        margin-bottom: 1em;
    }
    .btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show>.btn-secondary.dropdown-toggle {
        color: white;
        background-color: #57585B;
        border-color: white;
    }
    .btn-secondary {
        color: #DED9D9;
        background-color: rgb(126,127,116);
        border-color: rgb(106, 108, 112);
        font-size: 0.95rem;
    }
    .btn-secondary:hover {
        color: white;
        background-color: #323335;
        border-color: white;
    }
    .elementos-archivos-contenido {
         margin-top: 1%;
    }
    .elemento-lista-archivos {
        margin: 0;
    }
    .elemento-eliminar-archivo {
        cursor: pointer;
        margin-left: 4px;
    }
    .linea-vertical {
      width: 0px; /* Use only border style */
      height: 80%;  
      border: 1px inset; /* This is default border style for <hr> tag */
      margin-left: 6px;
    }
    .linea-horizontal {
        margin: 0;
    }
    .opciones-vaciar-listaDeArchivos {
        display: flex; 
        justify-content: flex-start;
    }

    .opcion-ver-listadoArchivos-agregados:hover {
        cursor: pointer;
    }

    .scroll-contenedor {
        height:200px;
        overflow:scroll;
        overflow-x:hidden;
    }

     .contenedor-listado-archivos {
        overflow-y: auto;
        max-height: 200px;
    }

    .contenedor-listado-archivos table {
        border-collapse: collapse;
        width: 100%;
        background-color: #7e7f74;
    }

    .contenedor-listado-archivos th {
        position: sticky;
        top: 0;
        background: #474749;
        border: 1;
    }
    .contenedor-puntero {
        background: var( --gris-pj-100);
        border-radius:2px;
        padding: 10px;
        border:1px solid #000;
        margin-bottom: 1.5em;
        color: #000;
    }

    .contenedor-cambio-seccion {
       display: flex;
       justify-content: space-between;
    }

    .texto-negro {
        color: black;
    }

    .sin-margen-superior {
        margin-top: 0px;
    }
    #tabla-archivos-descarga tbody
    {
        color:white !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/AltaDeContenido/CFormularioPasoDos.vue